import ChatbotGuidanceCase from './ChatbotGuidanceCase';

export default ChatbotGuidanceCase;